import { gql } from '@apollo/client'
import { Page } from 'components/organisms'
import { initializeApollo } from 'utils/apollo'
import Placeholder from 'components/molecules/Placeholder/Placeholder'
import { NextWrapper } from '../../data-fetching-wrapper'
import { useContentPagebuilder } from '../../utils/hooks'
import { InfiniteLoader } from '../../components/atoms'
import { getPlaceholder } from 'utils'

function Privacy({ pagina, content }) {
  const contentSelected = useContentPagebuilder(
    {
      key: 'content',
      objectId: pagina.pk,
    },
    content
  )

  return (
    <Page pagina={pagina}>
      {contentSelected ? (
        <Placeholder placeholder={contentSelected} />
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <InfiniteLoader />
        </div>
      )}
    </Page>
  )
}

export const getStaticProps = NextWrapper.getStaticProps(async ({ preview, previewData }) => {
  const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: gql`
      query {
        pagina(chiave: "privacy", preview: ${!!preview}) {
          pk
          titolo
          visibile
          pubblicato
          visibilitaDal
          visibilitaAl
          breadcrumbs {
            titolo
            url
          }
          seo {
            title
            description
            image
          }
          descrizione
          chiave
        }
      }
    `,
  })

  const placeholderParams = {
    key: 'content',
    objectId: pagina.pk,
    headers,
  }
  const content = await getPlaceholder(placeholderParams)

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: { pagina, content },
    revalidate: 60 * 5,
  }
})

export default Privacy
